import { createFileRoute } from '@tanstack/react-router';
import { SellPage } from '../../pages/SellPage';
import { SELLER_SHARE_PCT } from '../../features/seller-calculator/EstimateNote';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/sell')({
  head: () =>
    staticPageHead({
      path: '/sell',
      title: 'Sell your API on AnyAPI',
      description:
        `List your endpoint for an API in the AnyAPI catalog, set your price, and keep ` +
        `${SELLER_SHARE_PCT}% of what customers pay. See what you would have earned at your price.`,
      crumb: 'Sell your API',
    }),
  component: SellPage,
});
